import React from 'react';
import { useRcPortalWindowContext } from './useRcPortalWindowContext';
export function useSizeWithElRef(callback, enabled) {
    if (enabled === void 0) { enabled = true; }
    var ref = React.useRef(null);
    var _a = useRcPortalWindowContext().externalWindow, externalWindow = _a === void 0 ? window : _a;
    var callbackRef = function (_el) {
        void 0;
    };
    if (typeof externalWindow['ResizeObserver'] !== 'undefined') {
        var observer_1 = React.useMemo(function () {
            return new externalWindow['ResizeObserver'](function (entries) {
                var element = entries[0].target;
                if (element.offsetParent !== null) {
                    callback(element);
                }
            });
        }, [callback]);
        callbackRef = function (elRef) {
            if (elRef && enabled) {
                observer_1.observe(elRef);
                ref.current = elRef;
            }
            else {
                if (ref.current) {
                    observer_1.unobserve(ref.current);
                }
                ref.current = null;
            }
        };
    }
    return { ref: ref, callbackRef: callbackRef };
}
export default function useSize(callback, enabled) {
    if (enabled === void 0) { enabled = true; }
    return useSizeWithElRef(callback, enabled).callbackRef;
}
